import React, { useEffect, useState, useRef } from "react";
import ProductSlider from "../components/ProductSlider/ProductSlider";
import IncDecCounter from "../components/IncDecCounter/IncDecCounter";
import CountDownTimerText from "../components/CountDownText/CountDownTimerText";
import CurrencyInput from "react-currency-input-field";

import { SignalR_URL } from "../../configs/siteConfig";

import { Tooltip } from "react-tooltip";

import { Link, useParams  } from "react-router-dom";
import "./silentauctiondetail.css";
import { useDispatch, useSelector } from "react-redux";
import silent_Action from "../../redux/silent_auction/actions";
import Auth_Actions from "../../redux/auth/actions";
import bid_Action from "../../redux/bid/actions";
import moment from "moment";
import Swal from "sweetalert2";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import { HubConnectionBuilder,LogLevel } from '@microsoft/signalr';

// import * as Popup from "../components/Popup/index";
export default function SilentAuctionDetail() {
  const isAnonymouse = useRef(false);
  
  const [bidError, setbidError] = useState(false);
  let [nums, setNums] = useState(0);
  let [buyNowQuantity, setbuyNowQuantity] = useState(1);
  const { SilentID,shortcode } = useParams();
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.Auth);
  const Silent = useSelector((state) => state.SilentAuction);
  
  const [loadComplete, setLoadComplete] = useState(false);

  
  const [NumberOfBids, setNumberOfBids] = useState(Silent.item?.NumberOfBids);
  const [StartingBid, setStartingBid] = useState(Silent.item?.StartingBid);

  const [HighBidAmount, setHighBidAmount] = useState(Silent.item?.HighBid?.Amount);  
  const [BidIncrement, setBidIncrement] = useState(Silent.item?.BidIncrement);

  const [IsAnonymous, setIsAnonymous] = useState(Silent.item?.HighBid?.IsAnonymous);
  const [HighBidderIsAnonymous, setHighBidderIsAnonymous] = useState(Silent.item?.HighBid?.Bidder?.IsAnonymous);
  const [HighBidderFirstName, setHighBidderFirstName] = useState(Silent.item?.HighBid?.FirstName);
  const [HighBidderLastName, setHighBidderLastName] = useState(Silent.item?.HighBid?.LastName);
  const [BidEnd,setBidEnd] = useState(Silent.item?.BidEnd);
  const [IsOpen,setIsOpen] = useState(Silent.item?.IsOpen);
  const [IsExtended,setIsExtended] = useState(Silent.item?.IsExtended);

  const [ItemName,setItemName] = useState(Silent.item?.Name);
  const [ItemDescription,setItemDescription] = useState(Silent.item?.Description);
  const [LotNumber,setLotNumber] = useState(Silent.item?.LotNumber);  

  const [HasHighBid,setHasHighBid] = useState(Silent.item?.HighBid != null);  
  


const copyTextToClipBoard = (text) => {
  navigator.clipboard.writeText(text)
};

const BuyNowSubmit = () => {
  if (Auth.auth) {

    var selectBuild = '<select id="buyNowQuantity" className="form-input select-filter">';

    if(Silent.item?.Quantity > 1)
    {
      for(var i=1;i<=Silent.item?.Quantity;i++)
      {
        selectBuild = selectBuild + '<option value="'+ i +'">'+i+'</option>';
      }
    }
    else{
      selectBuild = selectBuild + '<option value="1">1</option>';
    }

    selectBuild = selectBuild + '</select>';    

    Swal.fire({
      showClass: {
        popup: 'animated fadeIn faster'
    },
    hideClass: {
        popup: 'animated fadeOut faster'
    },
      imageUrl: Silent.item?.Images?.length > 0 ? Silent.item.Images[0].Url : "../assets/images/donate-now.jpg",
      imageWidth: 400,
      //imageHeight: 200,
      buyNowQuantity,
      html: `<div class="popup-label"><p><b>Name: </b>${isAnonymouse.current.checked || Auth.profile.IsAnonymous ? "Anonymous":Auth.profile.FirstName+" "+Auth.profile.LastName}</p><p> <span><b>Buy Now Amount: </b> ${"$"}${Silent.item.BuyNowPrice}      
      </span></p><p><span><b>Quantity:</b> 
      `+selectBuild+`
      </span></p></div>`,
      title: ItemName,
      reverseButtons: true,
      confirmButtonText: "Confirm",
      showCancelButton: true,
      confirmButtonColor: "var(--accentColor)",
      cancelButtonColor: "var(--accentColor)",
    }).then((result) => {
      if (result.isConfirmed) {
        buyNowQuantity = document.getElementById('buyNowQuantity').value;
        dispatch(
          bid_Action.addToCart({
            data: {
              UserId: "",
              ItemId: SilentID,
              BidAmount: nums,
              BiddingPin: "",
              IsProxy: false,
              IsAnonymous: isAnonymouse.current.checked,
              IsBuyNow: true,
              PurchaseQuantity: buyNowQuantity
            },
            token: Auth?.auth?.access_token,
          })
        );
      }
    });
  } else {
    window.location.href = "/signin?returnUrl=" + window.location.pathname;      
  }
};

  const BidSubmit = () => {
    if (Auth.auth) {
      Swal.fire({
        showClass: {
          popup: 'animated fadeIn faster'
      },
      hideClass: {
          popup: 'animated fadeOut faster'
      },
        imageUrl:
          Silent.item?.Images?.length > 0
            ? Silent.item.Images[0].Url
            : "../assets/images/donate-now.jpg",
        imageWidth: 400,
        //imageHeight: 200,
        html: `<div class="popup-label"><p><b>Name: </b>${isAnonymouse.current.checked || Auth.profile.IsAnonymous ?"Anonymous":Auth.profile.FirstName+" "+Auth.profile.LastName}</p> <span><b>Amount: </b> ${
          "$" + formatter.format(nums)
        }</span></div>`,
        title: ItemName,
        reverseButtons: true,
        confirmButtonText: "Confirm",
        showCancelButton: true,
        confirmButtonColor: "var(--accentColor)",
        cancelButtonColor: "var(--accentColor)",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(
            bid_Action.addToCart({
              data: {
                UserId: "",
                ItemId: SilentID,
                BidAmount: nums,
                BiddingPin: "",
                IsProxy: false,
                IsAnonymous: isAnonymouse.current.checked,
                IsBuyNow: false,
                PurchaseQuantity: 0,
              },
              token: Auth?.auth?.access_token,
            })
          );
        }
      });
    } else {
      window.location.href = "/signin?returnUrl=" + window.location.pathname;      
    }
  };
 

  const maxBid = () => {
    if (Auth.auth) {
      Swal.fire({
        showClass: {
            popup: 'animated fadeIn faster'
        },
        hideClass: {
            popup: 'animated fadeOut faster'
        },
        imageUrl:
          Silent.item?.Images?.length > 0
            ? Silent.item.Images[0].Url
            : "../assets/images/donate-now.jpg",
        imageWidth: 400,
        //imageHeight: 200,
        html: `<div class="popup-label"><p><b>Name: </b>${isAnonymouse.current.checked || Auth.profile.IsAnonymous ?"Anonymous":Auth.profile.FirstName+" "+Auth.profile.LastName}</p> <span><b>Max Bid: </b> ${
          "$" + formatter.format(nums)
        }</span></div>`,
        title: ItemName,
        reverseButtons: true,
        confirmButtonText: "Confirm",
        showCancelButton: true,
        confirmButtonColor: "var(--accentColor)",
        cancelButtonColor: "var(--accentColor)",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(
            bid_Action.addToCart({
              data: {
                UserId: "",
                ItemId: SilentID,
                BidAmount: nums,
                BiddingPin: "",
                IsProxy: true,
                IsAnonymous: isAnonymouse.current.checked,
                IsBuyNow: false,
                PurchaseQuantity: 0,
              },
              token: Auth?.auth?.access_token,
            })
          );
        }
      });
    } else {
      window.location.href = "/signin?returnUrl=" + window.location.pathname;      
    }
  };

var loadSilentDetail = () => {
  setLoadComplete(false);            
  if (SilentID) {
    dispatch(
      silent_Action.silentItem({
        auctionId: Auth.auctionData?.Id,
        SilentID,
        token: Auth?.auth?.access_token,
        afterFunction: (itemData) => {
          
          setNumberOfBids(itemData.NumberOfBids);
          setBidIncrement(itemData.BidIncrement);          
          setStartingBid(itemData.StartingBid);
          setBidEnd(itemData.BidEnd);
          setIsOpen(itemData.IsOpen);
          setIsExtended(itemData.IsExtended);
          setItemName(itemData.Name);
          setItemDescription(itemData.Description);
          setLotNumber(itemData.LotNumber);


          if(itemData.HighBid != null)
          {
            setHasHighBid(true);
            setHighBidAmount(itemData.HighBid?.Amount);
            setIsAnonymous(itemData.HighBid?.IsAnonymous);
            setHighBidderIsAnonymous(itemData.HighBid?.Bidder?.IsAnonymous);
            setHighBidderFirstName(itemData.HighBid?.Bidder?.FirstName);
            setHighBidderLastName(itemData.HighBid?.Bidder?.LastName);
          }
          else{
            setHasHighBid(false);            
          }
          setLoadComplete(true);

        }
      })
    );
  }
};

useEffect(() => {


  const connection = new HubConnectionBuilder()
  .configureLogging(LogLevel.Error)
  .withUrl(SignalR_URL)   
  .build();  
  connection.start().then(() => 
    {
      console.log('Connected');
    })
  .catch(err => console.error('Error connecting to hub:', err));


connection.on(SilentID, message => {
  console.log('Item message:', message);  
  setNumberOfBids(message.NumberOfBids);   
  setBidIncrement(message.BidIncrement);  
  setStartingBid(message.StartingBid);
  setBidEnd(message.BidEnd);
  setIsOpen(message.IsOpen);
  setIsExtended(message.IsExtended);
  setItemName(message.Name);
  setItemDescription(message.Description);
  setLotNumber(message.LotNumber);

  setHasHighBid(message.HighBid != null);
  setIsAnonymous(message.HighBid?.IsAnonymous);  
  setHighBidAmount(message.HighBid?.Amount);
  setHighBidderIsAnonymous(message.HighBid?.Bidder?.IsAnonymous);
  setHighBidderFirstName(message.HighBid?.Bidder?.FirstName);
  setHighBidderLastName(message.HighBid?.Bidder?.LastName);
  

});


},[SilentID,Silent.item]);


  useEffect(() => {    
    if (shortcode) {
      dispatch(Auth_Actions.auction({ShortCode: shortcode,afterAction: loadSilentDetail}));
    }  
  
  

  }, [SilentID, Auth.auctionData?.Id, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const getDuration = (end) => {
    var now = moment(new Date()); //now
    const days = moment(end).diff(now, "days");
    const hrs = moment(end).diff(now, "hours") - days * 24;
    const mins = moment(end).diff(now, "minutes") - days * 1440 - hrs * 60;
    const sec = moment(end).diff(now, "seconds") - (days * 86400 + hrs * 3600 + mins * 60);
    
    if(days <= 0 && hrs <= 0 && mins <= 0 && sec <=0)
    {
      return 'Closed';
    }
    
    return `${days}days,  ${days > 0 ? hrs : 0}hrs, ${
      days > 0 ? mins : 0
    }mins, ${days > 0 ? sec : 0}sec`;
  };

  // Create our number formatter.
  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    currency: "USD",
  });

  return (
    <div>
      <section className="section novi-bg novi-bg-img breadcrumbs-custom" id="silent-auction-detail">
        <div className="container">
          <div className="breadcrumbs-custom__inner">
            {/* <p className="breadcrumbs-custom__title">Silent Auction</p> */}
            <ul className="breadcrumbs-custom__path">
              <li>
                <Link to={"/" + Auth?.auctionData?.ShortCode}>Home</Link>
              </li>
              <li>
                <Link to={"/silent-auction/" + Auth?.auctionData?.ShortCode}>Silent Auction</Link>
              </li>
            </ul>
            <ul className="list-inline-xxs next-prev next-prev-item">
              <li>
              { 
                Silent?.item?.PreviousItemId == null
                ? <Link to="/" className="disabledCursor button button-link" onClick={ (event) => event.preventDefault() }>previous</Link>
                : <Link className="button button-link" to={"/silent-auction/detail/" + Silent?.item?.PreviousItemId + "/" + Auth?.auctionData?.ShortCode}>previous</Link>
              }              
              </li>
              <li>&nbsp;|&nbsp;</li>
              <li>
              { 
                Silent?.item?.NextItemId == null
                ? <Link to="/" className="disabledCursor button button-link" onClick={ (event) => event.preventDefault() }>next</Link>
                : <Link className="button button-link" to={"/silent-auction/detail/" + Silent?.item?.NextItemId + "/" + Auth?.auctionData?.ShortCode}>next</Link>
              }                
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section novi-bg novi-bg-img section-md bg-default product-section">
        <div className="container">
          {bidError && (
            <div className="alert alert-danger" role="alert">
              Sign In first for Bidding.
            </div>
          )}
          {Silent.item && loadComplete ? (
            <div className="row row-fix row-10">
              <div className="col-md-6 col-lg-5">             
                <ProductSlider Img={Silent?.item?.Images} itemId={Silent.item.ItemId} isWatchlistItem={Silent.item.IsWatchlist} />
              </div>
              <div className="col-md-6 col-lg-7">
                <div className="product-single">
                  <span className="lot-number">Lot #{LotNumber}</span>
                  <h4>{ItemName}</h4>
                  <div className="row align-items-center">
                    <div className="col-12">
                    {Silent.item.DonatedBy != null && Silent.item.DonatedBy.length > 0 && 
                      <p className="product-stock">                      
                      Donated by {Silent.item.DonatedBy}
                      </p>
                      }
                    </div>
                  </div>

                  {IsExtended && IsOpen &&
                    <div class="extendedBidding-info extendedBidding-mobile">
                      <i class="fa fa-clock-o"></i>
                      <div class="extendedBidding-timer">
                        <p class="extendedBidding-text">Extended bidding enabled <a data-tooltip-id="extendedBidding"> 
                          <i className="fas fa-info-circle"></i></a>
                        </p>
                      
                        <Tooltip id="extendedBidding-timer">
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span class="s-tooltipInfo-span">{Silent?.item?.ExtendedBiddingText}</span>
                          </div>
                        </Tooltip>
                        <span class="extendedBid-time" key="timer1">Ends in <CountDownTimerText Time={BidEnd} OnlyMinutesAndSeconds={true}/></span> 
                      </div>                    
                    </div>
                  }
                    
                  {!Silent.item?.IsBuyNow && IsOpen && 
                    <IncDecCounter
                    readOnly={true}
                    setnumber={(e) => setNums(e)}
                    startnumber={HasHighBid ? HighBidAmount + BidIncrement : StartingBid}
                    increment={Silent.item ? BidIncrement : 1}
                    />
                  }                  

                  {Silent.item?.IsBuyNow && IsOpen &&  
                   <div className="buynowPriceBox">
                    <CurrencyInput
                     readOnly="readonly"                   
                    name="counterBuyNow"
                    prefix="$"
                    className="form-control"
                    placeholder="Please enter a number"                   
                    value={Silent.item?.BuyNowPrice}
                    />
                   </div>
                  }
                  
                  
                  {!Silent.item?.IsBuyNow && IsOpen &&                   
                      <button onClick={() => maxBid()} className="button button-primary maxBid">Max Bid</button>
                  }                  
                   
                  {!Silent.item?.IsBuyNow && IsOpen &&                   
                      <button onClick={() => BidSubmit()} className="button button-primary">bid now</button>                  
                  }                  
                    <div className="group-lg">
                      {IsOpen && (Silent.item?.IsBuyNow && Silent.item?.Quantity > 0 && (Silent.item?.HighBid != null ? HighBidAmount : StartingBid) < Silent.item?.BuyNowPrice) && 
                      <button onClick={() => BuyNowSubmit()} className="button button-primary buyNowButton">buy now</button>
                      }
                      {(Silent.item?.IsBuyNow && Silent.item?.Quantity <= 0) && 
                        "SOLD"
                      }
                  </div>


                  {!Silent.item?.IsBuyNow && IsOpen &&
                    <div className="form-wrap">
                      <label className="label-wrap">
                        Bid Anonymously
                        <input type="checkbox" ref={isAnonymouse} />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  }

                  {IsExtended && IsOpen &&
                    <div class="extendedBidding-info extendedBidding-largeScreens">
                      <i class="fa fa-clock-o"></i>
                      <div class="extendedBidding-timer">
                        <p class="extendedBidding-text">Extended bidding enabled <a data-tooltip-id="extendedBidding"> 
                          <i className="fas fa-info-circle"></i></a>
                        </p>
                      
                        <Tooltip id="extendedBidding-timer" >
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span class="s-tooltipInfo-span">{Silent?.item?.ExtendedBiddingText}</span>
                          </div>
                        </Tooltip>
                        
                        <span class="extendedBid-time" key="timer1">Ends in <CountDownTimerText Time={BidEnd} OnlyMinutesAndSeconds={true}/></span> 
                      </div>
                    
                    </div>
                  }
                  

                  {!IsOpen && !Silent.item?.IsBuyNow &&
                   <div className="group-lg closedMessageContainer">
                     <h4 className="closedMessage">ITEM IS CLOSED FOR BIDDING</h4>                   
                    </div>
                  }

                  {!IsOpen && Silent.item?.IsBuyNow &&
                   <div className="group-lg closedMessageContainer">
                     <h4 className="closedMessage">ITEM IS CLOSED</h4>                   
                    </div>
                  }

                  <div
                    className="product-text"
                    dangerouslySetInnerHTML={{
                      __html: ItemDescription,
                    }}
                  />
                  
                  <ul className="bid-list">
                  {(Silent.item?.IsBuyNow) && 
                    <li>
                    <span>Qty Available:</span>{" "}
                    {Silent.item?.Quantity}                  
                    </li>                      
                    }


                  {
                    Silent.item?.HighBid &&  
                    <li>
                      <span>High Bidder:</span>{" "}
                      {HighBidderIsAnonymous || IsAnonymous ? "Anonymous" : HighBidderFirstName + " " + HighBidderLastName}
                    </li>
                  }
                   
                   {Silent.item?.HighBid &&  
                    <li>
                        <span>High Bid:</span>
                        {"$"+formatter.format(HighBidAmount)}                      
                      </li>
                    }

                    {!Silent.item?.IsBuyNow && 
                      <li>
                        <span>Start Bid: </span>
                        {" $"+formatter.format(StartingBid)}
                      </li>                    
                    }
                    {!Silent.item?.IsBuyNow && 
                    <li>
                      <span>Increment:</span> {" $" + BidIncrement}
                    </li>
                    }
                    {Silent.item.SuggestedRetail > 0 && 
                    <li>
                      <span>Value:</span>{" "}
                      {"$"+formatter.format(Silent.item.SuggestedRetail)}
                    </li>
                    }
                     {!Silent.item?.IsBuyNow && 
                    <li>
                      <span># of Bids:</span>{" "}
                      {NumberOfBids}
                    </li>
                    }                    
                    <li>                      
                      <span>Closing:</span> <span key="timer2"><CountDownTimerText Time={BidEnd} /></span>
                    </li>
                    {IsExtended && IsOpen &&
                    <li>                      
                      <span>Extended: </span>
                      <a data-tooltip-id="extendedBidding"> 
                        <i className="fas fa-question-circle"></i>  
                      </a>
                      <Tooltip id="extendedBidding">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span class="s-tooltipInfo-span">{Silent?.item?.ExtendedBiddingText}</span>
                        </div>
                      </Tooltip>
                        
                         
                    </li>
                    }
                    <li>
                      <span>Share on:</span>                      
                      <a target="_blank" href={"https://www.facebook.com/sharer/sharer.php?u="+window.location.href} className="icon novi-icon icon-xxs icon-primary fa fa-facebook"></a>
                      <a target="_blank" href={"https://twitter.com/intent/tweet?text="+window.location.href} className="icon novi-icon icon-xxs icon-primary fa fa-twitter"></a>
                      <a href="mailto:" className="icon novi-icon icon-xxs icon-primary fa fa-envelope"></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            <div className="row row-fix row-10">
              {" "}
              <div className="col-md-12">
                {" "}
                <div id="page-loader">
                  <div className="cssload-container">
                    Loading... <div className="cssload-speeding-wheel"></div>
                  </div>
                </div>
              </div>{" "}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
